import { PureComponent } from 'react'
import { $ } from 'utils'
import styled from 'glamorous'
import Route from 'react-router-dom/Route'
import Redirect from 'react-router-dom/Redirect'
import Switch from 'react-router-dom/Switch'
import { Loader } from 'components'
import { graphql } from 'react-apollo'

import { Provider } from 'store'
import { CHECK_ACCOUNT as query } from 'queries'
import MainLayout from 'pages/MainLayout'
import SignLayout from 'pages/SignLayout'

const MainContainer = styled.div({
  height: '100vh',
})

const ErrorContainer = styled.div({
  maxHeight: '100px',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#eaea16',
  padding: '15px 20px',
  zIndex: 1100,
  transition: 'transform ease 1s',
  transform: 'translateY(-100%)',
}, ({ shown }) => shown && ({
  transform: 'translateY(0)',
}))


class App extends PureComponent {

  state = {
    errorMessage: '',
  }

  componentWillMount() {
    this.setState({ setErrorMessage: this.setErrorMessage })
  }

  setErrorMessage = (errorMessage) => {
    this.setState({ errorMessage })
    setTimeout(() => this.setState({ errorMessage: '' }), 5000)
  }

  render() {
    const { data: { loading, account } } = this.props
    return (
      $(Provider, {value: this.state},
        $(MainContainer,
          loading
            ? $(Loader)
            : !account
              ? $(Switch,
                  $(Route, { path: `/signIn`, component: SignLayout}),
                  $(Route, { path: `/signUp`, component: SignLayout}),
                  $(Redirect, { to: '/signIn'}))
              : $(Route, { path: `/`, render: () => $(MainLayout, { email: account.email })}),

          $(ErrorContainer, { shown: this.state.errorMessage.length > 0 }, this.state.errorMessage)
        )
      )
    )
  }
}


export default graphql(query, {
  options: {
    fetchPolicy: 'cache-first',
    errorPolicy: 'ignore'
  }
})(App)



// WEBPACK FOOTER //
// ./src/App.js